import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: 'transparent',
  backgroundImage: 'unset',
  marginTop: theme.spacing(3.75),
  [theme.breakpoints.up('md')]: {
      boxShadow: 'unset',
   },
   '&.Mui-expanded':{
    marginTop: theme.spacing(3.75),
  },
  '&.Mui-expanded:first-of-type': {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(3.75),
    },
    marginTop: theme.spacing(2.5),
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  '& .LGGroupTitle': {
    color: theme.palette.common.white,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(1.75),
      textDecoration: 'underline',
    },
    '&.LGGroupOtherLocations': {
      textDecoration: 'initial',
    },
  },
  '& .LGAccSummary': {
    padding: theme.spacing(1, 3),
    minHeight: 'unset',
    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
    '&.Mui-expanded': {
      [theme.breakpoints.up('md')]: {
        minHeight: 'unset',
      },
    },
    '& .MuiAccordionSummary-content ': {
      [theme.breakpoints.up('md')]: {
        margin: 0,
      },
      '&.Mui-expanded': {
        [theme.breakpoints.up('md')]: {
          margin: 0,
        },
      },
   }
},
'& .LGAccDetails':{
  padding: 0,
},
'& .LGAccIcon':{
  color: theme.palette.text.disabled,
  fontSize: theme.spacing(4.5),
},
}));
export default StyledAccordion;
